import * as Bixby from '$/core';
import { TokenService } from './TokenService';

export abstract class ConnectService {
  public static async logout(): Promise<void> {
    const route = Bixby.API.ServerRoute.forAction(
      Bixby.Constants.API_CONNECTCONTROLLER,
      Bixby.Constants.API_ACTION_CONNECT_LOGOUT
    );
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };

    await Bixby.API.postAnonymous<void>(route, '', config);

    TokenService.clearTokens();
  }

  public static async login(loginRequest: Bixby.Models.LoginRequest): Promise<void> {
    const route = Bixby.API.ServerRoute.forAction(
      Bixby.Constants.API_CONNECTCONTROLLER,
      Bixby.Constants.API_ACTION_CONNECT_TOKEN
    );
    const openIdRequest: Bixby.Models.OpenIdRequest & { [key: string]: string } = {
      grant_type: 'password',
      scope: 'offline_access',
      username: loginRequest.email,
      password: loginRequest.password,
      client_id: Bixby.Configuration.clientId,
      client_secret: Bixby.Configuration.clientSecret,
    };
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };
    const params = new URLSearchParams();
    Object.keys(openIdRequest).forEach(key => params.append(key, openIdRequest[key]));

    const openIdResponse: Bixby.Models.OpenIdResponse = await Bixby.API.postAnonymous<Bixby.Models.OpenIdResponse>(
      route,
      params.toString(),
      config
    );
    TokenService.setTokens(openIdResponse);
  }
}
